import Currency from "./Currency"

export enum E_TOURNAMENT_STATUS {
    NONE         = 0,
    ANNOUNCED    = 10,
    OPEN         = 20,
    IN_PLAY      = 30,
    FINISHED     = 40,
    CANCELED     = 50,
}

import {E_GAME_TYPE_BACKGAMMON} from "./Game"

export default class Tournament {
    uuid:string    
    bet_price:number
    win_total:number|null


    //type_id:      E_GAME_TYPE 
    game_type_id: E_GAME_TYPE_BACKGAMMON

    caption:string
    description:string|null
    rules:object
    max_score:number
    status: E_TOURNAMENT_STATUS
            
    created_timestamp:number
    start_timestamp:number     // when it should be started
    started_timestamp:number   // when it started
    next_timestamp:number      // next tour timestart
    finished_timestamp:number  

    players_count:number
    players_count_min:number
    players_count_max:number

    players_uuid_array: any

    player_rate_min: number    // 0 if no limit
    player_rate_max: number    // 0 if no limit

    tour_count:number
    tourCountMax:number    
        
    private _currencyBet:Currency|null  
    private _currencyWin:Currency|null  


    constructor(data:any) {
        Object.assign(this, data);  
        if(!this.players_uuid_array)       
            this.players_uuid_array = [];
    }

    get currencyBet()      {return this._currencyBet}
    set currencyBet(value) { this._currencyBet = value? new Currency(value): null;}

    get currencyWin()      {return this._currencyWin}
    set currencyWin(value) { this._currencyWin = value? new Currency(value): null;}    


    isDead():boolean { 
        return this.status == E_TOURNAMENT_STATUS.FINISHED || this.status == E_TOURNAMENT_STATUS.CANCELED;
    }    

    isInPlay():boolean { 
        return this.status == E_TOURNAMENT_STATUS.IN_PLAY;
    }   

    isPlayerInPlay(playerUuid:string):boolean  {
        return this.players_uuid_array.includes(playerUuid);
    }

    isOpen():boolean {
        return this.status == E_TOURNAMENT_STATUS.OPEN
    }

    isJoinable():boolean {
        return this.isOpen() && this.players_count < this.players_count_max;
    }

    isJoinableByPlayer(playerUuid:string):boolean {
        return this.isJoinable() && !this.isPlayerInPlay(playerUuid);
    }

    isRatingOk(value:number) {     
        if(this.player_rate_min && this.player_rate_min > value)
            return false;

        if(this.player_rate_max && this.player_rate_max < value)
            return false;

        return true;
    }


}